// Generated by /client/scripts/generate-icon-components.mjs
// DO NOT EDIT DIRECTLY

import type React from "react";

import layerSingleIcon from "@/assets/icons/layer-single.svg";

import { Icon, type IconProps } from "../Icon/Icon";

type LayerSingleIconProps = Omit<IconProps, "name">;

export function LayerSingleIcon(props: LayerSingleIconProps): React.ReactNode {
  return <Icon name={layerSingleIcon} {...props} />;
}
